import { v2 } from '@/api/client';

export const fetchUserMePermits = () => v2.get<Permit[]>('user/me/permit');
